import React, { useState, useEffect } from "react";
import { themes, supportLabel } from "services/constants";
import { showToast } from "services/utils/Status";
import * as Mui from "@mui/material";
import { useSelector } from "react-redux";
import { useFetch } from "services/hooks/useFetch";
import { customAPI } from "services/utils/CustomAPI";
import { CustomButtonWithOutLoader } from "components/CustomComponents/CustomButton";
import { rowEndStyle } from "services/constants/Styles";
export const Products = ({ modifiedData, setModifiedData }) => {
  const { domain, userDetails } = useSelector((state) => state.tokenReducer);
  const [tableHeight, setTableHeight] = useState(window.innerHeight * 0.7);
  const [productDetails, setProductDetails] = useState([]);
  const [firstTimeTrigger, setFristTimeTrigger] = useState(true);

  const {
    result: Products,
    loading,
    setLoad,
  } = useFetch(`${domain}products/list/`);

  useEffect(() => {
    const updateModuleAndProducts = () => {
      const filterData = Products.filter((item) => item.name !== supportLabel);
      setProductDetails(filterData);
      setFristTimeTrigger(false);
    };
    if (!loading && firstTimeTrigger) {
      setProductDetails([]);
      updateModuleAndProducts();
    }
  }, [Products, firstTimeTrigger, loading, userDetails?.type]);

  useEffect(() => {
    const updateHeight = () => {
      setTableHeight(window.innerHeight * 0.7);
    };

    window.addEventListener("resize", updateHeight);

    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  const updateProductCheckBoxDetails = (value, productName) => {
    let updatedProductValue = productDetails.map((product) => {
      if (product.name !== productName) return product;
      return {
        ...product,
        is_active: value,
      };
    });
    setProductDetails(updatedProductValue);
    setModifiedData(true);
  };

  const updateProductAndSubModule = async () => {
    const activeProductIds = productDetails
      .filter((item) => item.is_active)
      .map((item) => item.id);
    const response = await customAPI(`${domain}product-activation/`, "POST", {
      active_product_ids: activeProductIds,
    });
    if (response.ok) {
      showToast("success", "Products are updated successfully");
      setModifiedData(false);
    }
  };

  return (
    <React.Fragment>
      <Mui.Grid container sx={{ padding: 2 }}>
        <Mui.Grid xs={2}></Mui.Grid>
        <Mui.Grid xs={8} sx={{ minHeight: tableHeight }} component={Mui.Paper}>
          <Mui.Grid
            container
            sx={{ backgroundColor: themes.formBackground, padding: 1 }}
          >
            <Mui.Typography
              sx={{
                fontWeight: "bold",
                fontSize: 18,
                textAlign: "center",
                width: "100%",
              }}
            >
              Products
            </Mui.Typography>
          </Mui.Grid>
          <Mui.Grid container sx={{ width: "100%" }}>
            {productDetails?.map((data) => (
              <Mui.Grid container>
                <Mui.Grid xs={5}></Mui.Grid>
                <Mui.Grid container justifyContent="center" xs={3}>
                  <Mui.Grid xs={2}>
                    <Mui.Checkbox
                      checked={data?.is_active}
                      onChange={(event) => {
                        updateProductCheckBoxDetails(
                          event.target.checked,
                          data?.name
                        );
                      }}
                      size="medium"
                    />
                  </Mui.Grid>
                  <Mui.Grid xs={10}>
                    <Mui.Typography
                      sx={{
                        paddingTop: 1,
                        color: themes.headLine,
                        fontWeight: "bold",
                      }}
                    >
                      {data?.name}
                    </Mui.Typography>
                  </Mui.Grid>
                </Mui.Grid>
                <Mui.Grid xs={4}></Mui.Grid>
              </Mui.Grid>
            ))}
          </Mui.Grid>
        </Mui.Grid>
        <Mui.Grid xs={2}></Mui.Grid>
      </Mui.Grid>
      <Mui.Grid
        container
        sx={{
          ...rowEndStyle,
          paddingRight: 4,
          paddingTop: 2,
          paddingBottom: 2,
        }}
      >
        <CustomButtonWithOutLoader
          actionFuntion={() => {
            setLoad(true);
            setFristTimeTrigger(true);
            setModifiedData(false);
          }}
          actionName="Reset"
          typeName="button"
          disableAction={!modifiedData}
        />{" "}
        &nbsp;
        <CustomButtonWithOutLoader
          actionFuntion={() => {
            updateProductAndSubModule();
          }}
          actionName="Save"
          typeName="button"
          disableAction={!modifiedData}
        />
      </Mui.Grid>
    </React.Fragment>
  );
};
